import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'

import { Flex } from 'mailup-web-components'

import {
  SENDING_SOURCE_UNDEFINED,
  SENDING_SOURCE_IMMEDIATE,
  SENDING_SOURCE_SCHEDULED_NOW,
  SENDING_SOURCE_SCHEDULED,
  SENDING_SOURCE_TRIGGER,
  SENDING_SOURCE_ABTEST_TEST,
  SENDING_SOURCE_ABTEST_WINNER,
  SENDING_SOURCE_CAMPAIGN,
  SENDING_ABORT_REASON_INVALIDPEC
} from 'Constants'
import { SENDING_STATUS_NOT_DISTURB } from 'Constants/index'

const IconCell = ({ status, source, abortReason, withAnimation }) => {
  const intl = useIntl()
  let stringIdTootlip = ''
  const classNameList = []

  if (abortReason === SENDING_ABORT_REASON_INVALIDPEC) {
    classNameList.push('c-sendstatus-item__type--aborted')
    stringIdTootlip = 'Load.Schedulation.SendAborted'
  }

  switch (source) {
    case SENDING_SOURCE_UNDEFINED:
      classNameList.push('c-sendstatus-item__type--undefined')
      stringIdTootlip = 'Load.Schedulation.SendAborted'
      break

    case SENDING_SOURCE_IMMEDIATE:
      classNameList.push('c-sendstatus-item__type--immediate')
      stringIdTootlip = 'Load.Schedulation.SendTypeSequenziale'
      break

    case SENDING_SOURCE_SCHEDULED_NOW:
      classNameList.push('c-sendstatus-item__type--scheduled-now')
      stringIdTootlip = 'Load.Schedulation.SendTypeImmediato'
      break

    case SENDING_SOURCE_SCHEDULED:
      classNameList.push('c-sendstatus-item__type--scheduled')
      stringIdTootlip = 'Load.Schedulation.SendTypeProgrammato'
      break

    case SENDING_SOURCE_TRIGGER:
      classNameList.push('c-sendstatus-item__type--trigger')
      stringIdTootlip = 'Load.Schedulation.SendTypeTrigger'
      break

    case SENDING_SOURCE_ABTEST_TEST:
      classNameList.push('c-sendstatus-item__type--abtest-test')
      stringIdTootlip = 'Load.Schedulation.SendTypeABtest'
      break

    case SENDING_SOURCE_ABTEST_WINNER:
      classNameList.push('c-sendstatus-item__type--abtest-winner')
      stringIdTootlip = 'Load.Schedulation.SendTypeABtestWinner'
      break

    case SENDING_SOURCE_CAMPAIGN:
      classNameList.push('c-sendstatus-item__type--campaign')
      stringIdTootlip = 'Load.ContentsCampaignList.Campaign'
      break

    default:
      stringIdTootlip = 'Load.Schedulation.SendTypeAccodato'
  }

  return (
    <Flex
      alignItems='center'
      justifyContent='center'
      padding='24px 0 24px 16px'
      height='100%'
    >
      <span
        className={`c-sendstatus-item__type ${withAnimation &&
          status !== SENDING_STATUS_NOT_DISTURB &&
          'with-animation'} ${classNameList}`}
      >
        {!!stringIdTootlip && (
          <span data-tip={intl.formatMessage({ id: stringIdTootlip })} />
        )}
      </span>
    </Flex>
  )
}

export default IconCell

IconCell.propTypes = {
  status: PropTypes.any,
  source: PropTypes.any,
  abortReason: PropTypes.any,
  withAnimation: PropTypes.bool
}
